// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__3SuKJ","pos":"Placeholder_pos__3TImW","logo":"Placeholder_logo__2G2XB","desc":"Placeholder_desc__3NSkL"};